import React from 'react';
import {Dropdown} from "antd";
import IconBtn from "../../microComponents/elements/IconBtn";
import {CiMenuKebab} from "react-icons/ci";
import Confused from "./Confused";
import NumberInPallet from "./NumberInPallet";

const DropDownPallet = ({data}) => {
    const items =
        [
            {
                label: <Confused data={data}/>,
                key: '0',
            },

            {
                type: 'divider',
            },
            {
                label: <NumberInPallet data={data}/>,
                key: '3',
            },
        ]


    return (
        <div>
            <Dropdown
                menu={{
                    items
                }}
                trigger={['click']}
            >
                <IconBtn color='darkGrayIconBtn'
                > <CiMenuKebab size={20}/> </IconBtn>
            </Dropdown>
        </div>
    );
};

export default DropDownPallet;